import { _ as a } from "./_baseGetTag.js";
import { _ as c } from "./_getPrototype.js";
import { i as n } from "./isObjectLike.js";
var i = a, s = c, p = n, b = "[object Object]", f = Function.prototype, j = Object.prototype, e = f.toString, u = j.hasOwnProperty, l = e.call(Object);
function O(r) {
  if (!p(r) || i(r) != b)
    return !1;
  var o = s(r);
  if (o === null)
    return !0;
  var t = u.call(o, "constructor") && o.constructor;
  return typeof t == "function" && t instanceof t && e.call(t) == l;
}
var y = O;
export {
  y as i
};
//# sourceMappingURL=isPlainObject.js.map
